'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function newTranslation(lang) {
  return {
    lang: lang,
    contact_email: '',
    contact_name: '',
    contact_phone: '',
    contact_url: '',
    description: '',
    price_notes: '',
    subscription_email: '',
    subscription_phone: '',
    subscription_url: '',
    ticket_url: '',
    title: '',
    video_url: ''
  };
}

exports.default = { newTranslation: newTranslation };
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/translations.js
// module id = 992
// module chunks = 0